import $ from 'domtastic'
import barba from '@barba/core'
import { DOMPosition } from '@utils/utils'

// Transitions
import StepSlide from '@transitions/StepSlide'

// Views
import BaseView from '@views/_BaseView'


const { hooks } = barba




/* ROUTER
----------------------------------------------------------------------------------------------------*/

export default class Router {

    constructor() {
        this.$els = {
            doc       : $(document),
            body      : $('body'),
            router    : $('.router'),
            navItems  : $('.navItem'),
            langLinks : $('.header .langSwitch__link'),
        }

        this.views = {}

        this.isTransitioning = false
        this.pageTitle = document.title
        this.slug = document.location.pathname + document.location.search
        this.view = this.$els.body.attr('data-v')
        this.same = false


        // Kickstart navigation
        this.prepGlobalHooks()
        this.views = initRouting()
    }




    /* Hooks
    ---------------------------------------------------------*/

    prepGlobalHooks() {
        const { doc: $doc, body: $body } = this.$els

        hooks.beforeLeave(({ current }) => {
            this.isTransitioning = true

            $body.addClass('is-transitioning')
            $doc.trigger('pageWillChange', { current })


            // Blur menu elements
            if (document.activeElement.closest('.header')) {
                document.activeElement.blur()
            }


            // Remove current menu state
            this.$els.navItems.removeClass('is-current')
        })


        hooks.leave(({ current }) => {
            $(current.container).addClass('is-going')
            $doc.trigger('pageChange', { current })
        })


        hooks.afterLeave(({ current, next }) => {
            const $html = parser.parseFromString(next.html, 'text/html')
            this.nextView = $html.body.getAttribute('data-v')

            if (current.route) {
                this.previousView = current.route.name
            }

            $doc.trigger('pageGone', { nextViewName: this.nextView, next })
        })


        hooks.beforeEnter(({ next }) => {
            // Add current menu state if needed
            const $ctn = $(next.container)
            const $html = parser.parseFromString(next.html, 'text/html')
            const $nextBody = $html.querySelector('body')
            const $navLinks = $html.querySelectorAll('.navItem')
            const $activeLink = $html.querySelector('.navItem.is-current')
            const activeIndex = $($navLinks).indexOf($activeLink)


            if (activeIndex > -1) {
                this.$els.navItems.eq(activeIndex).addClass('is-current')
            }


            // Replace Lang nav links
            const langLinks = Array.from($html.querySelectorAll('.header .langSwitch__link')).map(l => l.getAttribute('href'))
            this.$els.langLinks.forEach((l, i) => {
                l.setAttribute('href', langLinks[i])
            })


            $body.attr('data-v', this.nextView)
            $body.attr('data-bg', $nextBody.dataset.bg)
            $ctn.addClass('is-coming')

            window.scrollTo(0, 0)
        })


        hooks.afterEnter(({ next }) => {
            this.currentView = this.nextView || this.currentView
            const $ctn = $(next.container)

            $doc.trigger('pageChangeEnd', { viewName: this.currentView, next })
            $ctn.removeClass('is-coming')

            manualScrollToHash($ctn[0])

            if (window.location.search.includes('topic=')) {
                const el = document.getElementById('list');
                if (el) {
                  el.scrollIntoView({ behavior: 'instant', block: 'start' });
                }
            }
        })


        hooks.after(() => {
            setTimeout(() => {
                // console.log('after')
                this.isTransitioning = false
                $body.removeClass('is-transitioning')
            }, 16)
        })
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const manualScrollToHash = ($ctn) => {
    let tY = 0

    if (window.location.hash.length) {
        const $el = $ctn.querySelector(window.location.hash)

        if (!$el) return

        tY = DOMPosition($el).y - APP.Layout.headerH
    }

    window.scrollTo(0, tY)
}


const initRouting = () => {
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual'
    }

    // barba.use(router, { routes })

    barba.init({
        timeout: 5000,
        preventRunning: true,
        // debug: true,

        prevent: ({ el }) => {
            // Exclude links with hreflang
            if (el.getAttribute('hreflang')) return true;
            // Exclude anchor links (href starts with # or contains a hash)
            const href = el.getAttribute('href');
            if (href && href.startsWith('#')) return true;
            if (href && href.includes('#')) return true;
            return false;
        },  

        transitions: [
            StepSlide,
        ],

        views: [
            new BaseView(),
            new BaseView({ namespace: 'step' }),
        ],
    })

    return barba.views.byNamespace
}


const parser = new DOMParser()



